export default __webpack_public_path__ + "static/media/subWebContacts.0485acda.png";